// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__32eOB","title":"ClientCherryInfo_title__3uyrp","itemText":"ClientCherryInfo_itemText__1nSAV"};